import { useTranslation } from "react-i18next";
import { ActionsType } from "@/components/custom/data-table/buttons/data-table-actions";
import {
  DeleteAction,
  OperationalHoursAction,
  UploadCatalogAction,
} from "./-site-groups-actions-components";
import { PiTrash, PiClock, PiUpload } from "react-icons/pi";

export const useActions = (): ActionsType => {
  const { t } = useTranslation();

  return [
    {
      label: t("delete"),
      title: t("deleteSiteGroups"),
      actionContent: DeleteAction,
      icon: PiTrash,
    },
    {
      label: t("operationalHours"),
      title: t("updateOperationalHours"),
      actionContent: OperationalHoursAction,
      icon: PiClock,
    },
    {
      label: t("uploadCatalog"),
      title: t("uploadCatalog"),
      actionContent: UploadCatalogAction,
      icon: PiUpload,
    },
  ];
};
